import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components/macro";
import Image from "../Image";

const StyledWideMedia = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  padding-top: 56.25%;
  overflow: hidden;
`;

const StyledVideoWrap = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: black;
  background-size: cover;
  background-position: center;
  background-image: url(${({ backgroundImage }) => backgroundImage});

  iframe {
    width: 100.1%; // prevent background from being visible
    height: 100.1%; // prevent background from being visible
  }
`;

const WideMedia = ({
  image,
  imageSources,
  alt,
  width,
  height,
  video,
  controls,
  poster,
}) => {
  return (
    <StyledWideMedia>
      {video && (
        <StyledVideoWrap backgroundImage={poster}>
          <iframe
            title="Video Hero"
            src={`https://player.vimeo.com/video/${video}?background=${
              controls ? 0 : 1
            }`}
            width="100%"
            height="100%"
            frameBorder="0"
            allow="autoplay; fullscreen"
            allowFullScreen=""
          ></iframe>
        </StyledVideoWrap>
      )}
      {!video && image && (
        <Image
          src={image}
          alt={alt}
          sources={imageSources}
          width={width}
          height={height}
          useAsBackground
        />
      )}
    </StyledWideMedia>

    // <StyledWideMedia>
    //   {video ? (
    //     <StyledVideoWrap>
    //       <iframe
    //         title="Video Hero"
    //         src={`https://player.vimeo.com/video/${video}?background=1`}
    //         width="100%"
    //         height="100%"
    //         frameBorder="0"
    //         allow="autoplay; fullscreen"
    //         allowFullScreen=""
    //       ></iframe>
    //     </StyledVideoWrap>
    //   ) : (
    //     <Image src={image} />
    //   )}
    // </StyledWideMedia>
  );
};

WideMedia.propTypes = {
  image: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  alt: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  imageSources: PropTypes.oneOfType([PropTypes.array, PropTypes.bool]),
  width: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]),
  height: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]),
};

export default WideMedia;
